var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPagesLine = function SvgPagesLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.7 8.4v10.8h12.6V8.4zm0-1.8h12.6V4.8H5.7zM19.2 21H4.8a.9.9 0 0 1-.9-.9V3.9a.9.9 0 0 1 .9-.9h14.4a.9.9 0 0 1 .9.9v16.2a.9.9 0 0 1-.9.9M7.5 10.2h3.6v3.6H7.5zm0 5.4h9v1.8h-9zm5.4-4.5h3.6v1.8h-3.6z"
  })));
};
export default SvgPagesLine;